
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_sqn6e_99",
  "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_sqn6e_99",
  "divider": "awsui_divider_x7peu_sqn6e_104",
  "divider-disabled": "awsui_divider-disabled_x7peu_sqn6e_118",
  "divider-active": "awsui_divider-active_x7peu_sqn6e_121",
  "resizer": "awsui_resizer_x7peu_sqn6e_125",
  "has-focus": "awsui_has-focus_x7peu_sqn6e_182",
  "tracker": "awsui_tracker_x7peu_sqn6e_205"
};
  